import { render, staticRenderFns } from "./visitasAdmin.vue?vue&type=template&id=aedfba8e"
import script from "./visitasAdmin.vue?vue&type=script&lang=js"
export * from "./visitasAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports